import Abstract from "../../../abstract-view/abstract.js";

export default class Breadcrumbs extends Abstract {
  constructor(element) {
    super();

    this._element = element;
  }

  getElement() {
    return this._element;
  }

  setElement(element) {
    this._element = element;
  }

  getContent() {
    return this._element.outerHTML;
  }

  setContent(content) {
    this._element.outerHTML = content;
  }
}
